import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../_app/types";

const Scale = ({ size }: PropsAdronIcon) => {
  const theme: Theme = useTheme();

  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : undefined}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.66683 14H11.3335M8.00016 2V14M2.00016 4.66667H3.3335C4.66683 4.66667 6.66683 4 8.00016 3.33333C9.3335 4 11.3335 4.66667 12.6668 4.66667H14.0002M10.6668 10.6667L12.6668 5.33333L14.6668 10.6667C14.0868 11.1 13.3868 11.3333 12.6668 11.3333C11.9468 11.3333 11.2468 11.1 10.6668 10.6667ZM1.3335 10.6667L3.3335 5.33333L5.3335 10.6667C4.7535 11.1 4.0535 11.3333 3.3335 11.3333C2.6135 11.3333 1.9135 11.1 1.3335 10.6667Z"
          stroke={theme.palette.text.primary}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default Scale;
